<template>
    <v-card>
        <v-card-title>Edit Global Registry Factor Type</v-card-title>
        <v-card-text>
            <v-autocomplete v-model="globalRegistryId"
                            :items="globalRegistries"
                            item-title="displayName"
                            item-value="id"
                            label="Global Registry"
            />
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script setup lang="ts">

import { onMounted, ref } from "vue";
import {
    GlobalRegistryFactorType,
    SavedGlobalRegistryFactorType,
} from "@/services/conditions/conditionFactors/conditionFactorsAPI";
import { registriesAPI, SavedRegistrySchema } from "@/services/registries/registriesAPI";
import { withLoadingScreen } from "@/lib/loading";

const { globalRegistryFactorType } = defineProps<{
    globalRegistryFactorType?: SavedGlobalRegistryFactorType | undefined;
}>();

const emit = defineEmits<{
    (e: "onSave", globalRegistryFactorType: GlobalRegistryFactorType | SavedGlobalRegistryFactorType): void;
}>();

onMounted(async () => {
    await fetchRegistrySchemas();
});

const globalRegistries = ref<SavedRegistrySchema[]>([]);
const globalRegistryId = ref<string>( globalRegistryFactorType ? globalRegistryFactorType.globalRegistryId : "");

async function save() {
    emit("onSave", {
        ...globalRegistryFactorType,
        globalRegistryId: globalRegistryId.value!,
    });
}

async function fetchRegistrySchemas() {
    await withLoadingScreen(async () => {
        globalRegistries.value = await registriesAPI.fetchAllRegistrySchemas();
    });
}

</script>
